import { render, staticRenderFns } from "./GoogleAuthenticator.vue?vue&type=template&id=b04d802e&"
import script from "./GoogleAuthenticator.vue?vue&type=script&lang=js&"
export * from "./GoogleAuthenticator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports